<template>
  <div id="main" style="min-height: 65vh">
    <div class="container" v-loading="loadingData">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-lg-5 part part__1">
          <div class="content">
            <div class="t-1">
              Reward Management
            </div>
            <hr>

            <div class="item-p1">
              <div class="s1">
                Your Holdings:
              </div>
              <div class="s2">
                <countTo :startVal='0' :endVal='dkz_balance' :duration='100'></countTo>
                DogeKongZilla
              </div>
            </div>
            <hr>

            <div class="item-p1">
              <div class="s1">
                Pending Rewards:
              </div>
              <div class="s2">
                <div>
                  {{ contractInfo.pendingReward }} BNB
                  <button type="button" class="btn btn-warning btn-sm"
                          :disabled="contractInfo.secondsUntilAutoClaimAvailable>0"
                          @click="claimReward()">Claim
                  </button>
                </div>
                <div>
                  Time left to claim: {{ contractInfo.secondsUntilAutoClaimAvailable }} seconds
                </div>
              </div>
            </div>
            <hr>

            <div class="item-p1">
              <div class="s1">
                Total Rewards:
              </div>
              <div class="s2">
                {{ contractInfo.totalReward }} BNB
              </div>
            </div>
            <hr>

            <div class="item-p1">
              <div class="s1">
                Queue Position:
              </div>
              <div class="s2">
                {{ contractInfo.queuePosition }}
              </div>
            </div>
            <hr>

          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-lg-7 part part__2">
          <div class="content">

            <div class="t-1">
              Token Reward
            </div>
            <hr>

            <div class="item-p3">
              <div class="s1">
                Current token reward:
              </div>
              <div class="s2">
                <div class="s2-1">
                   <span class="badge badge-pill badge-warning" v-if="!contractInfo.hasUserCustomRewardToken">
                  BNB
                  </span>
                  <span class="badge badge-pill badge-warning" v-if="contractInfo.hasUserCustomRewardToken">
                    {{ contractInfo.infoCustomRewardToken.name }} ({{ contractInfo.infoCustomRewardToken.symbol }})
                  </span>
                </div>
                <div class="s2-2">
                  <div class="text-center" v-if="contractInfo.hasUserCustomRewardToken">
                    <button type="button" class="btn btn-warning btn-sm" @click="revertToBNBTokenReward()">
                      Revert to BNB
                    </button>
                  </div>
                </div>
              </div>

            </div>
            <hr>


            <div style="margin-bottom: 20px">
              <base-alert type="warning" :dismissible="true">
                <slot name="text">
                  Only accept BEP-20 token that is listed on Pancakeswap except
                  <b>$DogeKongZilla</b>
                </slot>
              </base-alert>
            </div>

            <div class="item-p2">
              <div class="s1">
                Add custom token reward:
              </div>
              <div class="s2">

                <div class="input-group input-group-alternative">
                  <input class="form-control" v-model="value_custom_token" placeholder="Token address" type="text">
                </div>

              </div>
            </div>

            <div class="or-class">
              <hr>
              <div class="text-or">
                Or
              </div>
            </div>

            <div class="item-p2 mt-2">
              <div class="s1">
                Choose tokens available:
              </div>
              <div class="s2">
                <div class="s2-1">
                  <el-select :disabled="connected_wallet === null" @change="changeSelectCustomToken"
                             v-model="value_select_token"
                             placeholder="Select Token">
                    <el-option
                        v-for="item in listTokenCustom"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="set-token-reward">
              <button @click="setCustomTokenReward()" type="button" :disabled="value_custom_token==''"
                      class="btn btn-primary btn-sm">
                Set Custom Reward Token
              </button>
            </div>
          </div>

          <!--          <div class="content">-->
          <!--            Recent Transactions-->
          <!--          </div>-->
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
import {mapGetters} from "vuex";

export default {
  name: "MainCpn",
  components: {countTo},
  props: {
    contractInfo: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: null
    },
    loadingData: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      'dkz_balance',
      'connected_wallet'
    ]),
    tokenCustom() {
      let v = this
      if (this.contractInfo != null) {
        let result = this.contractInfo.currentRewardToken
        this.listTokenCustom.forEach(item => {
          if (item.value.toLowerCase() == v.contractInfo.currentRewardToken.toLowerCase()) {
            result = item.label
          }
        })
        return result
      }
      return ''
    },
  },
  data() {
    return {
      amount: 0,
      pending_reward: 0,
      total_reward: 0,
      queue_position: 0,
      symbol_reward: 'BNB',
      listTokenCustom: [
        {
          value: '0x55d398326f99059ff775485246999027b3197955',
          label: 'USDT'
        }, {
          value: '0x3ee2200efb3400fabb9aacf31297cbdd1d435d47',
          label: 'ADA'
        }, {
          value: '0x1d2f0da169ceb9fc7b3144628db156f3f6c60dbe',
          label: 'XRP'
        }, {
          value: '0x7083609fce4d1d8dc0c979aab8c869ea2c873402',
          label: 'DOT'
        }, {
          value: '0x2859e4544c4bb03966803b044a93563bd2d0dd4d',
          label: 'SHIB'
        }, {
          value: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
          label: 'DOGE'
        }
      ],
      value_select_token: '',
      value_custom_token: '',

    }
  },
  methods: {
    changeSelectCustomToken(val) {
      this.value_custom_token = val
    },
    claimReward() {
      this.$emit('claimReward')
    },
    revertToBNBTokenReward() {
      this.$emit('revertToBNBReward')
    },
    setCustomTokenReward() {
      this.$emit('setCustomRewardToken', this.value_custom_token)
    }
  }
}
</script>

<style scoped lang="scss">

#main {
  margin-top: 70px;

  .part {

    .content {
      border: 1px solid #5e72e4;
      padding: 20px;
      border-radius: 20px;
      margin-bottom: 30px;

      .t-1 {
        text-align: center;
        font-size: 18px;
        font-weight: bold;
      }

      .or-class {
        width: 30%;
        font-weight: 500;
        color: #5e72e4;
        font-size: 14px;
        position: relative;

        .text-or {
          position: absolute;
          top: -9px;
          left: 20px;
          background-color: white;
          padding: 0px 10px;
        }
      }

      .item-p1 {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 14px;

        .s1 {
          width: 40%;
          font-weight: 500;
          color: #5e72e4;
        }

        .s2 {
          width: 60%;
          text-align: right;
        }
      }

      .item-p2 {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        align-items: center;

        .s1 {
          width: 40%;
          font-weight: 500;
          color: #5e72e4;


        }

        .s2 {
          width: 60%;
          text-align: right;
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .s2-1 {
            width: 100%
          }

          .badge-warning {
            font-size: 16px;
          }

          .el-select {
            width: 100% !important;
          }
        }
      }

      .item-p3 {
        display: flex;
        flex-wrap: wrap;
        font-size: 14px;
        align-items: center;

        .s1 {
          width: 40%;
          font-weight: 500;
          color: #5e72e4;


        }

        .s2 {
          width: 60%;
          text-align: right;
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .s2-1 {
            width: calc(100% - 115px);
            text-align: left;
          }

          .s2-2 {
            width: 115px;

          }

          .badge-warning {
            font-size: 16px;
          }

          .el-select {
            width: 100% !important;
          }
        }
      }

      .set-token-reward {
        text-align: center;
        margin-top: 30px;
      }

    }

    &__1 {

    }

    &__2 {
      padding-left: 30px;
    }
  }

}

</style>
